"use client";

import { LIBUM_DEV_MAIL_URL } from "@/lib/constants";
import { Mail } from "lucide-react";
import Link from "next/link";

type HelperProps = {
  name: string;
};

export function MsgQuestion({ name }: HelperProps) {
  return (
    <div className="mt-auto w-full pt-8">
      <div className="mx-auto grid w-full grid-cols-2 gap-2 rounded-lg bg-card px-6 py-4 text-left shadow-lg md:flex md:items-center md:justify-between">
        <p className="text-sm font-normal">
          Have a question about <span className="font-bold">{name}</span>?
        </p>
        <p className="text-sm font-medium">
          <Link
            href={LIBUM_DEV_MAIL_URL}
            target="_blank"
            rel="noreferrer"
            className="-m-1 flex items-center justify-end rounded-sm p-1 hover:text-gray-1100 focus-visible:outline-2 focus-visible:outline-offset-0 focus-visible:outline-brand-primary hover:dark:text-gray-100"
          >
            <Mail size={14} className="mr-1.5 mt-px text-muted" />
            Contact us
          </Link>
        </p>
      </div>
    </div>
  );
}
